import { vehiclesColumns } from 'common/list-configs/vehicles.config';

const {
  photo,
  owner,
  facilityCode,
  deviceId,
  year,
  make,
  model,
  cardClass,
  licenseNumber,
  licenseState,
  smartPlateId,
  color,
  rantingDates,
  validityPeriod: validationDates,
  status,
  additionalInformation,
  parkSpaceNumber,
  registrationAddress,
  isShared,
  transponder,
  isDeactivated,
  cardAccessLastActivityDate,
  dateVehicleAdded,
} = vehiclesColumns();
export const vehicleInitialColumns = [
  photo,
  owner,
  facilityCode,
  deviceId,
  year,
  make,
  model,
  color,
  cardClass,
  licenseNumber,
  licenseState,
  smartPlateId,
  rantingDates,
  validationDates,
  registrationAddress,
  parkSpaceNumber,
  additionalInformation,
  status,
  isShared,
  transponder,
  isDeactivated,
  cardAccessLastActivityDate,
  dateVehicleAdded,
];
